import React from 'react';
import TextWithIcon from '../../../../components/Input/TextWithIcon';
import AssignmentIndOutlined from '@material-ui/icons/AssignmentIndOutlined'

export default ({lastModifiedBy}) => {
    return (<div style={{position: 'relative'}}>
                <TextWithIcon label="Last modified by" value={lastModifiedBy} icon={AssignmentIndOutlined}/>
            </div>)
}